module.exports = __webpack_public_path__ + "img/1.4f122679.jpeg";